
import { Vue, Component, Prop } from 'vue-property-decorator';

const S3_LINK_PREFIX = 's3-key://';

@Component({})
export default class CrudLink extends Vue {
  @Prop({ default: '' }) readonly valuePath!: string;
  @Prop({ default: null }) value!: string;
  @Prop({ type: Object }) readonly properties!: object;
  @Prop() readonly disabled!: boolean;
  @Prop() readonly linkText!: boolean | string;

  get url() {
    if (this.value?.startsWith(S3_LINK_PREFIX)) {
      const url = new URL(this.value);
      const regex = /^\/{3,}/;
      if (regex.test(url.pathname)) {
        url.searchParams.set('leading_slash', 'true');
      }
      const parsedUrl = url.toString().slice(S3_LINK_PREFIX.length);
      return `/api/media/file/${parsedUrl}`;
    }
    return this.value;
  }

  get _linkText() {
    if (typeof this.linkText === 'string') {
      return this.linkText;
    }
    if (this.linkText === true) {
      const lastSlash = this.value.lastIndexOf('/');
      if (lastSlash < 0) {
        return this.value;
      }
      return this.value.slice(lastSlash + 1);
    }
    return this.value;
  }
}
